<template>
    <el-dropdown size="small" class="d2-mr">
        <span class="btn-text">你好 {{info.name}}</span>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="UserData">
                <d2-icon name="user" class="d2-mr-5"/>
                个人资料
            </el-dropdown-item>
            <el-dropdown-item @click.native="ChangePwd">
                <d2-icon name="keyboard-o" class="d2-mr-5"/>
                修改密码
            </el-dropdown-item>
            <el-dropdown-item @click.native="logOff" divided>
                <d2-icon name="power-off" class="d2-mr-5"/>
                注销
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        computed: {
            ...mapState('d2admin/user', [
                'info'
            ])
        },
        methods: {
            ...mapActions('d2admin/account', [
                'logout'
            ]),
            /**
             * @description 登出
             */
            logOff() {
                this.logout({
                    vm: this,
                    confirm: true
                })
            }, UserData() {
                this.$store.dispatch('d2admin/page/open', {
                    name: 'user-index',
                    path: 'user',
                    params: {},
                    query: {}
                })
                // this.$store.open('blog/change/'+row.id)
                location.href = '/#/user'
            }, ChangePwd() {
                this.$store.dispatch('d2admin/page/open', {
                    name: 'user-pwd',
                    path: 'user',
                    params: {},
                    query: {}
                })
                // this.$store.open('blog/change/'+row.id)
                location.href = '/#/user/pwd'
            }
        }
    }
</script>
